<template>
  <transition name="fade" appear mode="out-in">
    <div class="spinner" v-if="$store.getters['searchStore/isSearching']" key="spinning">
      <!-- <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> -->
      <!-- <span class="sr-only">Loading...</span> -->
      <div class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          :style="`width: ${$store.getters['searchStore/searchingProgress']}%`"
        >{{$store.getters['searchStore/searchingProgress']}}%</div>
      </div>
    </div>
    <div v-else key="showing">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {};
</script>

<style scoped>
.spinner {
	margin-top: 50px;
}
.fade-enter {
	opacity: 0;
}
.fade-enter-active {
	/* opacity: 1; default already is 1 */
	transition: opacity 0.2s;
}
.fade-leave {
	/* opacity: 1; default already is 1 */
}
.fade-leave-active {
	opacity: 0.5;
	transition: opacity 0.5s;
}
</style>
